// react
import React, { useEffect, useState, useRef } from "react";
// utils
import getTrad from "./../../utils/getTrad"
// style
import "./Tuto.css"

const Tuto = (props) => {

	const [step, setStep] = useState(false)

	const [display, setDisplay] = useState(false)
	const [message, setMessage] = useState("")
	const [substep, setSubstep] = useState(0)

	useEffect(() => {

		if(step){

			setDisplay(true)

			setMessage(getTrad("tuto00", props.lang))

			setTimeout(function(){
				setMessage(getTrad("tuto01", props.lang))
				setSubstep(1)
			}, 3000)

			setTimeout(function(){
				setMessage(getTrad("tuto02", props.lang))
				setSubstep(2)
			}, 6000)

			setTimeout(function(){
				setDisplay(false)
			}, 9000)
		}else{
			setStep(true)
		}
		
	}, [props.restart])

	return (
		<React.Fragment>
			<div
				className="tuto-container"
				style={{
					display:display ? "block" : "none"
				}}
			>
				<div className="tuto-popup">
					<p className="tsv5">{message}</p>
					<div className={"tuto-img tuto-img-0"+substep+""}></div>
				</div>
			</div>
			
		</React.Fragment>
	)
}

export default Tuto;